export default __webpack_public_path__ + "img/0bd3b314200367d364d050f6f1de43bd.png";